import {
    modelServices
} from '@/app/shared/services/client-agent-service.js';
import {
    httpClient
} from '@/app/shared/services/http-client/http-client.js';

export class PaymentService {

    InitPharmacyPaymentPopup(entitiesList, callback, errCallback) {
        var entitiesListIds = [];

        //Serialize Entities
        if (entitiesList && entitiesList.length > 0) {
            for (let i = 0; i < entitiesList.length; i++) {
                entitiesListIds += "entitiesList[" + i + "]=" + entitiesList[i];
            }
        }

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("InitPharmacyPaymentPopup").URL + "?"+ entitiesListIds;
    
        return httpClient.get(url).then(callback).catch(errCallback);

    }

    ConfirmPharmacyPaymentTransaction(payment, callback, errCallback) {

        var url = modelServices.baseUrl + modelServices.getPharmacyServiceName("ConfirmPharmacyPaymentTransaction").URL;

        return httpClient.post(url, payment).then(callback).catch(errCallback);

    }

    GetPharmacyEmployeeList(workingAt, callback) {
        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("GetPharmacyEmployeeList").URL}` + "?ParentID=" + workingAt.ParentID + "&GrandParentID=" + workingAt.GrandParentID + "&ChildID=" + workingAt.ChildID;
        return httpClient.get(url).then(callback);

    }

    PreviewReceipt(receiptId, callback) 
    {
        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("PreviewReceipt").URL}?receiptId=${receiptId}`
        return httpClient.get(url).then(callback);

    }


}

const paymentService = new PaymentService();

export { paymentService };